const Glide = window.Glide;
import {
  disableIfGlideFit,
  setButtonsVisibility,
} from "../../../Scripts/glideControls.js";
const galleryWidget = (() => {
  function setUpCarousel() {
    const sliders = document.querySelectorAll(
      ".block__sectionGalleryWrapper .block__lowerContainer .glide"
    );
    const slides = document.querySelectorAll(
      ".block__lowerContainer > .glide > .glide__track > .glide__slides > .glide__slide > *"
    );
    const sections = document.querySelectorAll(".section__gallery");
    let glidesModal = [];
    let glides = [];
    const modals = Array.from(sliders).map((slider) =>
      document.querySelector(
        `.reveal[id='${slider.getAttribute("data-open")}']`
      )
    );
    const closeButtons = Array.from(sliders).map((slider) =>
      document.querySelector(
        `.reveal[id='${slider.getAttribute("data-open")}'] .close-button`
      )
    );
    const sliderModals = document.querySelectorAll(".reveal > .glide.gallery");

    const options = {
      perView: 2,
      peek: { before: 0, after: 91 },
      bound: true,
      gap: 16,
      rewind: false,
      breakpoints: {
        649: {
          perView: 1,
          peek: { before: 0, after: 74 },
          gap: 16,
        },
        1022: {
          perView: 1,
          peek: { before: 0, after: 156 },
          gap: 13,
        },
        1199: {
          perView: 1,
          gap: 18,
          peek: { before: 0, after: 202 },
        },
        1365: {
          perView: 1,
          gap: 16,
          peek: { before: 0, after: 150 },
        },
      },
    };
    const handleSlideOpenModal = (e) => {
      glidesModal.forEach((glide) => {
        let parentGlideOfSlide =
          e.target.parentElement.parentElement.parentElement.parentElement;
        let modal = glide.selector.parentElement;
        if (modal.getAttribute("id") === parentGlideOfSlide.dataset.open) {
          glide.go(`=${e.target.dataset.index}`);
        }
      });
    };
    const initalizeGlides = () => {
      sliders.forEach((slider) => {
        let glide = new Glide(slider, options);
        glide.on("move.after", () => {
          let firstButton = glide.selector.querySelector(
            ".button__glide.button__prev"
          );
          let lastButton = glide.selector.querySelector(
            ".button__glide.button__next"
          );
          let numOfSlides =
            glide.selector.querySelectorAll(".glide__slide").length;
          setButtonsVisibility(glide, firstButton, lastButton, numOfSlides);
        });
        glides.push(glide.mount());
      });

      window.dispatchEvent(new Event("resize"));
    };

    initalizeGlides();

    sliderModals.forEach((sliderModal) => {
      glidesModal.push(
        new Glide(sliderModal, {
          perView: 1,
          gap: 37,
          peek: { before: 236, after: 236 },
          bound: true,
          rewind: false,
          dragThreshold: false,
          breakpoints: {
            767: {
              perView: 1,
              gap: 0,
              peek: { before: 0, after: 0 },
            },
            1023: {
              perView: 1,
              gap: 30,
              peek: { before: 81, after: 81 },
            },
            1365: {
              perView: 1,
              gap: 37,
              peek: { before: 73, after: 73 },
            },
            1920: {
              perView: 1,
              gap: 37,
              peek: { before: 236, after: 236 },
            },
          },
        }).mount()
      );
    });

    slides.forEach((slide) => {
      slide.addEventListener("click", handleSlideOpenModal);
    });

    // add class to parent element - has selector currently does not work for firefox browsers so we can't check that way using css
    // additionally sections have overflow hidden to prevent moving backgrounds from overflowing out of sections with no bg so using
    // negative margin is ineffective
    sections.forEach((section) => {
      section.parentElement.parentElement.classList.add("has-sectionGallery");
    });
    modals.forEach((modal) => {
      if(!modal)
        return;
      $(document).on(
        "open.zf.reveal",
        `[id=${modal.getAttribute("id")}]`,
        function () {
          window.dispatchEvent(new Event("resize"));
        }
      );
      $(document).on(
        "closed.zf.reveal",
        `[id=${modal.getAttribute("id")}]`,
        function () {
          document.documentElement.classList.remove("is-reveal-open");
        }
      );
    });

    const handleCloseButton = () => {
      document.dispatchEvent(new Event("closed.zf.reveal"));
    };
    closeButtons.forEach((clsbtn) => {
      if(!clsbtn)
        return;
      clsbtn.addEventListener("click", handleCloseButton);
    });
    for (let i = 0; i < glides.length; i++) {
      disableIfGlideFit(glides[i]);
    }

    if (sliders) {
      window.addEventListener("resize", () => {
        for (let i = 0; i < glides.length; i++) {
          disableIfGlideFit(glides[i]);
        }
      });
    }
  }
  setUpCarousel();
  // add a mutation observer to watch the HTML element for changes to top position caused by modal

  const htmlElement = document.documentElement;
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "style"
      ) {
        const topPosition = window
          .getComputedStyle(htmlElement)
          .getPropertyValue("top");
        if (topPosition == "auto") {
          // modal has closed shrink every glide track and revert back to original width to prevent slide
          // bug
          glides.forEach((glide) => {
            const glideSlides = glide.selector.querySelector(".glide__slides");
            if (glideSlides) {
              let originalWidth = glideSlides.style.width;
              glideSlides.style.width = "1px";
              // trigger reflow
              glideSlides.offsetHeight;
              glideSlides.style.width = originalWidth;
            }
          });
        }
      }
    });
  });

  observer.observe(htmlElement, {
    attributes: true,
    attributeFilter: ["style"],
  });
  return {setUpCarousel: setUpCarousel};
})();

export {galleryWidget};